export default __webpack_public_path__ + "static/media/heart.6951e0a8.svg";